import { Link } from "react-router-dom";
import type { Film } from "@/types/content";

interface RankingListProps {
  films: Film[];
}

export default function RankingList({ films }: RankingListProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50">
      <div className="flex items-center justify-between border-b border-background-200 px-4 py-3">
        <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-950">
          <i className="ri-fire-line text-accent-600" />
          热门排行
        </h3>
        <span className="text-[11px] text-foreground-400">按站内热度</span>
      </div>
      <ol className="divide-y divide-background-200">
        {films.map((film, index) => (
          <li key={film.id}>
            <Link
              to={`/detail/${film.id}`}
              className="group flex cursor-pointer items-center gap-3 px-4 py-3 transition-colors hover:bg-background-100"
            >
              <span
                className={
                  index < 3
                    ? "flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary-500 text-xs font-bold text-background-50"
                    : "flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-background-200 text-xs font-medium text-foreground-600"
                }
              >
                {index + 1}
              </span>
              <div className="h-14 w-10 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={film.cover}
                  alt={`${film.title} 封面`}
                  title={`${film.title} - 三级片电影详情介绍`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-foreground-900 group-hover:text-primary-700">
                  {film.title}
                </p>
                <p className="mt-1 flex items-center gap-2 text-[11px] text-foreground-500">
                  <span>{film.year}</span>
                  <span className="text-background-400">·</span>
                  <span className="truncate">{film.region}</span>
                </p>
                <div className="mt-1.5 h-1 w-full overflow-hidden rounded-full bg-background-200">
                  <div
                    className="h-full rounded-full bg-accent-400"
                    style={{ width: `${film.heat}%` }}
                  />
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}